<template>
  <RolesForm is-edit />
</template>

<script>
import RolesForm from '@/layouts/components/form/RolesForm.vue'

export default {
  components: { RolesForm },
}
</script>
